import React from "react";

export default function SignUp() {
  return (
    <div className="SignUpBar">
      <a href="https://loyalty.intouchposenterprise.com/registration/Milano">Sign Up Now</a>&nbsp; To Start Earning
      Rewards
    </div>
  );
}
